module.exports = __webpack_public_path__ + "static/img/Gallery09.2fac404.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls46-1/Gallery09.jpg
// module id = F82o
// module chunks = 12